<nz-list [nzItemLayout]="'horizontal'">
  <nz-comment *ngFor="let comment of comments" [nzAuthor]="comment.authorName" [nzDatetime]="comment.creationTimestamp">
    <nz-comment-content>
      <div class="comment">
        <ng-container *ngIf="comment.jobOpportunityId; else normalComment">
          <div class="comment__body">
            <div class="comment__job-opportunity">
              <h4>
                <a [routerLink]="['/admin/job-offer-matches', comment.jobOpportunityId]">
                  {{ comment.jobOpportunityName }}
                </a>
              </h4>
              <p *ngIf="comment.stage">{{ "admin.comment.stage" | translate }}: {{ comment.stage.name | translate }}</p>
            </div>
            <p *ngIf="comment.missionPartnerId">
              <span>{{ "admin.comment.mission-partner" | translate }}:</span>
              <a [routerLink]="['/admin/mission-partner-view', comment.missionPartnerId]">
                {{ comment.missionPartnerName }}
              </a>
            </p>
            <p *ngIf="comment.forMissionPartnerId">
              <span>{{ "admin.comment.for-mission-partner" | translate }}:</span>
              <a [routerLink]="['/admin/mission-partner-view', comment.forMissionPartnerId]">
                {{ comment.forMissionPartnerName }}
              </a>
            </p>
            <p class="comment__text">{{ comment.text }}</p>
          </div>
        </ng-container>

        <ng-template #normalComment>
          <p>{{ comment.text }}</p>
        </ng-template>

        <div class="comment__actions">
          <button
            *ngIf="!editingCommentId || editingCommentId === comment.commentId"
            class="comment__edit-btn"
            nz-button
            nzType="link"
            nzShape="circle"
            (click)="startEditing(comment)"
          >
            <span nz-icon nzType="edit" nzTheme="outline"></span>
          </button>
          <button
            *ngIf="editingCommentId === comment.commentId"
            class="comment__cancel-btn"
            nz-button
            nzType="link"
            nzShape="circle"
            (click)="cancelEditing()"
          >
            <span nz-icon nzType="close" nzTheme="outline"></span>
          </button>
          <button
            *ngIf="!editingCommentId"
            class="comment__delete-btn"
            nz-button
            nzType="link"
            nzShape="circle"
            (click)="confirmDeleteComment(comment)"
          >
            <span nz-icon nzType="delete" nzTheme="outline"></span>
          </button>
        </div>
      </div>
    </nz-comment-content>
  </nz-comment>
</nz-list>

<nz-comment>
  <nz-comment-content>
    <form nz-form [formGroup]="formGroup" (ngSubmit)="handleSubmit()">
      <nz-form-item>
        <nz-form-control [nzSpan]="24" [nzErrorTip]="textErrorTpl">
          <textarea nz-input rows="4" formControlName="text"></textarea>
          <ng-template #textErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')">{{
              "admin.comment.error.required" | translate
            }}</ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <div class="comment-form-actions">
        <div class="comment-destination-container" *ngIf="!editingCommentId">
          <nz-form-item class="comment-destination-item">
            <nz-form-label [nzNoColon]="true" nz-col nzFlex="none">Destination</nz-form-label>
            <nz-form-control nz-col nzFlex="none">
              <nz-select formControlName="destination" class="comment-destination-select">
                <nz-option nzValue="notes" nzLabel="Notes"></nz-option>
                <nz-option nzValue="job-match" nzLabel="Job Offer"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
  
          <nz-form-item *ngIf="formGroup.get('destination')?.value === 'job-match'" class="comment-job-match-item">
            <nz-form-label [nzNoColon]="true" nz-col nzFlex="none">Job Offer</nz-form-label>
            <nz-form-control [nzErrorTip]="'Please select a job offer'" nz-col nzFlex="auto">
              <nz-select formControlName="selectedJobId" nzShowSearch nzAllowClear (nzOnSearch)="onSearchJobOffer()" [nzLoading]="isLoadingMatches" nzPlaceHolder="Select Job Offer" class="comment-job-match-select">
                <nz-option 
                  *ngFor="let match of matchedJobOpportunities" 
                  [nzValue]="match.jobOpportunity.id" 
                  [nzLabel]="match.jobOpportunity.name">
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>

        <nz-form-item class="comment-submit-item submit-btn">
          <button nz-button nzType="primary">
            {{ (editingCommentId ? "admin.comment.button.update" : "admin.comment.button.add") | translate }}
          </button>
        </nz-form-item>
      </div>
    </form>
  </nz-comment-content>
</nz-comment>
